import { logError } from '@/shared/lib/apiHelpers';
import { toastrError } from '@/shared/lib/toastNotification';
import handleStartHolterStudyProcessing from '../api/services/handleStartHolterStudyProcessing';

/**
 * Kicks off backend Holter study processing for one study and profile. Wraps both ids into the mutation input and awaits handleStartHolterStudyProcessing, logging the error and surfacing it as an error toast when the call throws.
 *
 * @param studyId - Study to start processing for.
 * @param profileId - Profile owning the study.
 * @returns A promise resolving to the mutation result, or to undefined when the call failed.
 */
export const callStartHolterStudyProcessing = async (studyId: string, profileId: string) => {
  try {
    const input = {
      studyId,
      profileId,
    };
    const result = await handleStartHolterStudyProcessing(input);
    return result;
  } catch (error) {
    logError(error.message, error);
    toastrError(error.message, 'Error');
  }
};
